import { useEffect } from "react";

export default function useSEO(p) {
  useEffect(() => {
    // Title
    document.title = p.title;

    const add = (attr, name, content) => {
      if (!content) return;
      let tag =
        document.querySelector(`meta[${attr}="${name}"]`) ||
        document.createElement("meta");
      tag.setAttribute(attr, name);
      tag.setAttribute("content", content);
      document.head.appendChild(tag);
    };

    add("name", "description", p.description);
    add("name", "keywords", p.keywords);
    add("name", "robots", p.robots || "index, follow");
    add("name", "publisher", p.publisher);
    add("name", "X-Robots-Tag", p.robots || "index, follow"); // fallback

    add("property", "og:title", p.title);
    add("property", "og:description", p.description);
    add("property", "og:image", p.image);
    add("property", "og:url", p.url);

    add("name", "twitter:card", "summary_large_image");
    add("name", "twitter:title", p.title);
    add("name", "twitter:description", p.description);
    add("name", "twitter:image", p.image);

    if (p.canonical) {
      let link =
        document.querySelector("link[rel='canonical']") ||
        document.createElement("link");
      link.rel = "canonical";
      link.href = p.canonical;
      document.head.appendChild(link);
    }

    if (p.lang) document.documentElement.lang = p.lang;
  }, [p]);
}
